import React from "react";
import Grid from "../../partials/content/Grid";
import { Table } from "react-bootstrap";
import { getStatus } from "../../crud/auth.crud";
import EditIcon from '@material-ui/icons/Edit';
 import { Link } from "react-router-dom";
 import { Tooltip } from "@material-ui/core";
 import { IconButton } from '@material-ui/core';
 import Button from '@material-ui/core/Button';

export default class AccountStatus extends React.Component {
  state = {
    statuses:[]
  }
  componentDidMount()
  {
    
    getStatus().then(response => response.data)
    .then((data) => {
      this.setState({ statuses: data })
      //console.log(this.state.users)
     })
  }
  render() {
    return (
      <>
        <div className="row">
          <div className="col-md-12">
            <Grid beforeCodeTitle="Status" jsCode="true">
              <div className="kt-section">
               
                <Table striped bordered hover>
                  <thead>
                    <tr>
                     
                      <th>Status Name</th>
                      <th>Status Color</th>
                      <th>Description</th>
                      <th>Edit</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                  {this.state.statuses.map((status) => (
                    <tr>
                      
                      <td>{status.statusName} <button type="button" className="btn btn-danger btn-elevate btn-circle btn-icon" style={{'background-color':status.statusId,'border-color':status.statuId, 'height':'10px', 'width':'10px'}}></button></td>
                      <td>{status.statusId}</td>
                      <td>{status.statusDescription}</td>
                      <td>
                          {status.isEditable &&
                          <Link  to={{pathname:"/editaccstatus", data: {status:status}}}>
                           <Tooltip
                                    title="Edit Status" 

                                  >
                            <IconButton>
                              <EditIcon style={{ color: '#5578eb',fontSize: 12}}/>   
                            </IconButton>
                            </Tooltip>
                          </Link>
                          }
                      </td>
                    </tr>
                    ))}
                </tbody>
                </Table>
              </div>
            </Grid>
          </div>
         
        </div>

      

       
      </>
    );
  }
}
